import StatsIcon from '@/CustomIcons/StatsIcon'
import StopIcon from '@/CustomIcons/StopIcon'
import { useUserContext } from '@/UserContext'
import { Card } from '@/components/SessionSettings/internal/Card'
import { CardHeader } from '@/components/SessionSettings/internal/CardHeader'
import { Field } from '@/components/SessionSettings/internal/Field'

interface ProAudioStatsSectionProps {
    aeNetworkStats: { serverPing: number | null }
}

export function ProAudioStatsSection({ aeNetworkStats }: ProAudioStatsSectionProps) {
    const [userState] = useUserContext()

    return (
        <Card className="px-0 md:px-0">
            <CardHeader icon={StatsIcon} title="Pro Audio" className="px-[30px]" />
            <div className="flex flex-col gap-[16px] pt-[41px] w-full">
                <Field title="Available">
                    <div className="flex gap-[4px]">
                        {userState.audioEngineState.isLoaded ? (
                            <StopIcon className="text-muse-success ml-[-6px]" style={{ fontSize: '1.3rem' }} />
                        ) : (
                            <StopIcon className="text-muse-danger ml-[-6px]" style={{ fontSize: '1.3rem' }} />
                        )}
                        <div className="font-[400]">{userState.audioEngineState.isLoaded ? 'True' : 'False'}</div>
                    </div>
                </Field>
                <Field title="Network connection state">
                    <div className="flex gap-[4px]">
                        {userState.audioEngineState.lastConnectionEvent === 'CONNECTED' ||
                        userState.audioEngineState.lastConnectionEvent === 'CONNECTING' ||
                        userState.audioEngineState.lastConnectionEvent === 'INITIAL' ? (
                            <StopIcon className="text-muse-success ml-[-6px]" style={{ fontSize: '1.3rem' }} />
                        ) : (
                            <StopIcon className="text-muse-danger ml-[-6px]" style={{ fontSize: '1.3rem' }} />
                        )}
                        <div className="font-[400]">
                            {String(userState.audioEngineState.lastConnectionEvent).charAt(0).toUpperCase() +
                                String(userState.audioEngineState.lastConnectionEvent).slice(1).toLowerCase()}
                        </div>
                    </div>
                </Field>
                <Field title="Ping (server)">
                    <div className="font-[400]">{aeNetworkStats.serverPing || ''} ms</div>
                </Field>
            </div>
        </Card>
    )
}
